<template>
  <div class="login-main">
    <nav-bar ref="navigateRef"></nav-bar>

    <section class="login-start-main">
      <div class="container review-main text-capitalize position-relative">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="center-card overflow-hidden d-flex flex-column">

              <!-- Banner + Logo -->
              <div class="center-card-box">
                <div class="sign-main">
                  <div class="sign-top login-logo-main position-relative">
                    <img
                      :src="$auth.getSigninImage()"
                      @error="$event.target.src = noImge"
                      class="img-fluid sign-banner"
                      alt="banner"
                    />
                    <div class="login-logo position-absolute">
                      <img
                        :src="$auth.getFlatIcon()"
                        @error="$event.target.src = noImge"
                        class="sign-logo"
                        alt="logo"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Form Area -->
              <div class="center-card-box px-3 mb-3 mt-3 flex-grow-1 d-flex flex-column">
                <h3 class="text-center fw-semibold mt-2 p-3 mb-4" v-if="$auth.setting && $auth.setting.login_signup_page_text">
                  {{ $auth.setting.login_signup_page_text }}
                </h3>

                <!-- Back Arrow -->
                <!-- <div class="d-flex align-items-center mt-4" v-if="is_display_button">
                  <div class="map-add-cls me-3">
                    <a href="javascript:void(0)" @click="openPreviewPage()">&lt;</a>
                  </div>
                </div> -->

                <!-- Phone Flow -->
                <div v-if="is_phone">
                  <!-- Enter Mobile Number -->
                  <div class="number-boxs position-relative" v-if="checkMobile">
                    <vue-country-code
                      :enabledCountryCode="true"
                      :enableSearchField="true"
                      :defaultCountry="country_code"
                      @onSelect="onSelect"
                    ></vue-country-code>
                    <i class="fas fa-phone-alt"></i>
                    <input
                      class="form-control mb-0 h50"
                      type="tel"
                      v-model="$v.mobile_number.$model"
                      placeholder="Enter your Mobile Number"
                      :class="{ 'is-invalid': $v.mobile_number.$error }"
                      @keyup.enter="checkNumber"
                    />
                    <div class="tc-main mt-2">
                      <p>A One Time Password(OTP) will be sent via SMS.</p>
                    </div>
                    <div v-if="$v.mobile_number.$error" class="invalid-feedback d-block">
                      <span v-if="!$v.mobile_number.required">Please enter phone number</span>
                      <span v-else-if="!$v.mobile_number.numeric">Please enter valid number</span>
                    </div>
                  </div>

                  <!-- Password (for existing user) -->
                  <div class="number-boxs position-relative" v-if="showPassword">
                    <h6 class="mb-2">Enter Your Password</h6>
                    <i class="fas fa-lock"></i>
                    <input
                      class="form-control mb-0 h50"
                      :type="show ? 'text' : 'password'"
                      v-model.trim="$v.password.$model"
                      placeholder="Password"
                      @keyup.enter="LogIn"
                      :class="{ 'is-invalid': $v.password.$error }"
                      style="padding-right: 45px"
                    />
                    <div class="eyeButton" @click="show = !show">
                      <i :class="show ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </div>
                    <div v-if="$v.password.$error" class="invalid-feedback d-block">
                      <span v-if="!$v.password.required">Please enter password</span>
                    </div>
                    <div class="text-end mt-2">
                      <a href="/forgot-password">Forgot Password?</a>
                    </div>
                  </div>

                  <!-- OTP Input Section -->
                  <div class="otp-boxs mt-4 position-relative" v-if="showOtp">
                    <h6>Enter OTP</h6>
                                      
                    <!-- OTP Inputs -->
                    <div class="digit-group">
                      <input 
                        type="text" 
                        id="digit-1" 
                        maxlength="1" 
                        autofocus 
                        @input="handleOtpInput" 
                        @keydown="handleOtpBackspace"
                        @paste="handleOtpPaste"
                      />
                      <input 
                        type="text" 
                        id="digit-2" 
                        maxlength="1" 
                        @input="handleOtpInput" 
                        @keydown="handleOtpBackspace" 
                      />
                      <input 
                        type="text" 
                        id="digit-3" 
                        maxlength="1" 
                        @input="handleOtpInput" 
                        @keydown="handleOtpBackspace" 
                      />
                      <input 
                        type="text" 
                        id="digit-4" 
                        maxlength="1" 
                        @input="handleOtpInput" 
                        @keydown="handleOtpBackspace" 
                      />
                      <input 
                        type="text" 
                        id="digit-5" 
                        maxlength="1" 
                        @input="handleOtpInput" 
                        @keydown="handleOtpBackspace" 
                      />
                      <input 
                        type="text" 
                        id="digit-6" 
                        maxlength="1" 
                        @input="handleOtpInput" 
                        @keydown="handleOtpBackspace" 
                      />
                    </div>

                    <!-- Timer/Resend Section -->
                    <div class="otp-timer-section">
                      <span v-if="countDown > 0">
                        <i class="far fa-clock"></i> {{ countDown }}s
                      </span>
                      <a v-else class="resend" @click="resendCode">
                        <i class="fas fa-redo-alt"></i> Resend Code
                      </a>
                    </div>
                  </div>

                  <div id="recaptcha-container" style="display: none;"></div>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex align-items-center mt-4" v-if="is_display_button">
                  <div class="d-flex align-items-center mr-2" v-if="is_display_button">
                    <div class="signin-back-btn">
                      <a href="javascript:void(0)" @click="openPreviewPage()">
                        <i class="fas fa-arrow-left"></i>
                      </a>
                    </div>
                  </div>
                  <div class="btn-sets flex-grow-1">
                    <button
                      class="nxt-btn w-100"
                      @click="checkNumber"
                      :disabled="is_btn_spinner"
                      v-if="checkMobile"
                    >
                      <b-spinner small v-if="is_btn_spinner" class="spinner"></b-spinner>
                      <span v-else>Next</span>
                    </button>

                    <button
                      class="nxt-btn w-100"
                      @click="LogIn"
                      :disabled="is_btn_spinner"
                      v-if="showPassword"
                    >
                      <b-spinner small v-if="is_btn_spinner" class="spinner"></b-spinner>
                      <span v-else>Submit</span>
                    </button>

                    <button
                      class="nxt-btn w-100"
                      @click="verifyOTP"
                      :disabled="is_btn_spinner"
                      v-if="showOtp"
                    >
                      <b-spinner small v-if="is_btn_spinner" class="spinner"></b-spinner>
                      <span v-else>Verify OTP</span>
                    </button>
                  </div>
                </div>

                <!-- Initial Phone Button -->
                <div class="tab-cls-section" v-if="!is_display_button">
                  <button class="phone-signup" @click="swipeTab('phone')">
                    <i class="fas fa-phone-alt"></i> Phone
                  </button>
                </div>

                <SocialLogin v-if="!is_display_button" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import SocialLogin from "@/components/SocialLogin.vue";
import { mapActions } from "vuex";
import { required, numeric } from "vuelidate/lib/validators";
import Login from "../apis/login";
import firebase from "firebase";
import noImge from "@/assets/images/logo-placeholder-image.png";

export default {
  name: "SignIn",
  components: {
    NavBar,
    Footer,
    SocialLogin
  },
  data: function() {
    return {
      noImge: noImge,
      mobile_number: "",
      country_code: "91",
      password: "",
      show: false,
      showPassword: false,
      showOtp: false,
      checkMobile: true,
      is_display_button: false,
      is_phone: false,
      is_btn_spinner: false,
      countDown: 0,
      resendpass: false,
      prevRoute: null,
      timer: null   // ← ONLY ADDED THIS LINE
    };
  },

  validations: {
    mobile_number: { required, numeric },
    password: { required }
  },

  beforeRouteEnter: function(to, from, next) {
    next(function(vm) {
      vm.prevRoute = from;
    });
  },

  mounted: function() {
    if (this.$auth.user) {
      this.$router.push({ name: "home" });
    }

    if (this.$auth.setting && !firebase.apps.length) {
      this.$auth.setFireBaseSettings();
    }

    if (this.$auth.setting && this.$auth.setting.country_code) {
      this.country_code = this.$auth.setting.country_code;
    }

    if (localStorage.getItem("isFromSignUpMobile")) {
      this.mobile_number = localStorage.getItem("mobile_number") || "";
      this.is_display_button = true;
      this.is_phone = true;
      localStorage.removeItem("isFromSignUpMobile");
    }
  },

  beforeDestroy: function() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  methods: {
    ...mapActions("user", ["checkMobileNumber"]),
    ...mapActions("address", ["getUserNearAddressData"]),

    onSelect(data) {
      this.country_code = data.dialCode;
    },

    swipeTab(type) {
      this.is_display_button = true;
      this.is_phone = type === "phone";
      this.checkMobile = true;
      this.showPassword = false;
      this.showOtp = false;
      this.$v.$reset();
    },

    openPreviewPage() {
      this.is_display_button = false;
      this.is_phone = false;
      this.mobile_number = "";
      this.password = "";
      this.showOtp = false;
      this.showPassword = false;
      this.$v.$reset();
    },

    initReCAPTCHA() {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
      }

      try {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container", {
          size: "invisible",
          callback: () => {
            console.log('reCAPTCHA solved');
          },
          "expired-callback": () => {
            console.log('reCAPTCHA expired');
          }
        });

        window.recaptchaVerifier.render();
      } catch (error) {
        console.error('reCAPTCHA initialization error:', error);
        this.$toasted.error('Failed to initialize verification');
      }
    },

    checkNumber() {
      this.$v.mobile_number.$touch();
      if (this.$v.mobile_number.$invalid) return;

      this.is_btn_spinner = true;
      this.initReCAPTCHA();

      Login.CheckMobileNumber({
        vendor_id: this.$auth.getVendorId(),
        user_role: "1",
        mobile_number: this.mobile_number,
        is_langauge: this.$store.state.lang.locale
      }).then((res) => {
        if (res.data && res.data.code === 200) {
          this.showPassword = true;
          this.checkMobile = false;
          this.is_btn_spinner = false;
        } else {
          if (this.$auth.setting && this.$auth.setting.verify_otp === "Yes") {
            this.sendOTP();
          } else {
            this.$router.push({ name: "sign-up" });
          }
        }
        this.is_btn_spinner = false;
      }).catch(() => {
        this.is_btn_spinner = false;
      });
    },

    sendOTP() {
      const phoneNumber = "+" + this.country_code + this.mobile_number;

      firebase.auth().signInWithPhoneNumber(phoneNumber, window.recaptchaVerifier)
        .then((confirmationResult) => {
          window.confirmationResult = confirmationResult;
          this.showOtp = true;
          this.checkMobile = false;
          this.startCountdown(); // ← Fixed countdown starts here
        })
        .catch((error) => {
          this.handleFirebaseError(error);
          this.is_btn_spinner = false;
        });
    },

    verifyOTP() {
      const code = this.getOtpCode();
      if (!code || code.length !== 6) {
        this.$toasted.error("Please enter valid OTP");
        return;
      }

      this.is_btn_spinner = true;
      window.confirmationResult.confirm(code)
        .then(() => {
          this.loginAfterOTP();
        })
        .catch((err) => {
          this.$toasted.error(err.code === "auth/invalid-verification-code" ? "Invalid OTP" : "Verification failed");
          this.is_btn_spinner = false;
        });
    },

    loginAfterOTP() {
      const loginData = {
        mobile_number: this.mobile_number,
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale
      };

      this.$auth.login(loginData, () => {
        this.is_btn_spinner = false;
        this.redirectAfterLogin();
      });
    },

    LogIn() {
      this.$v.$touch();
      if (this.$v.password.$invalid) return;

      this.is_btn_spinner = true;
      const loginData = {
        mobile_number: this.mobile_number,
        password: this.password,
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale
      };

      this.$auth.login(loginData, () => {
        this.is_btn_spinner = false;
        this.redirectAfterLogin();
      });
    },

    redirectAfterLogin() {
      const refsData = this.$refs.navigateRef;
      if (localStorage.getItem("userCurrentlatitude") && localStorage.getItem("userCurrentlongitude")) {
        this.getUserNearAddressData({
          vendor_id: this.$auth.getVendorId(),
          user_id: this.$auth.user.user_id,
          latitude: localStorage.getItem("userCurrentlatitude"),
          longitude: localStorage.getItem("userCurrentlongitude"),
          is_langauge: this.$store.state.lang.locale
        }).then((res) => {
          if (res.code === 200 && refsData && refsData.selectDefaultAddress) {
            refsData.selectDefaultAddress(res.Result);
          }
        });
      }
      this.$router.push({ name: "home" }).catch(() => {});
    },

    getOtpCode() {
      let code = "";
      for (let i = 1; i <= 6; i++) {
        const el = document.getElementById("digit-" + i);
        if (el) code += el.value;
      }
      return code;
    },

    handleOtpInput(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
      if (e.target.value && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
    },

    handleOtpBackspace(e) {
      if (e.key === "Backspace" && !e.target.value && e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
      }
    },

    startCountdown() {
      if (this.timer) clearInterval(this.timer);

      this.countDown = 60;
      this.resendpass = false;

      this.timer = setInterval(() => {
        this.countDown--;
        this.$set(this, 'countDown', this.countDown); // ← This fixes Vue 2.6.11 reactivity

        if (this.countDown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.resendpass = true;
        }
      }, 1000);
    },

    resendCode() {
      this.countDown = 0;
      this.resendpass = false;
      this.initReCAPTCHA();
      this.sendOTP();
    },

    handleFirebaseError(error) {
      let msg = "Authentication failed";
      if (error.code === "auth/invalid-phone-number") msg = "Invalid phone number";
      else if (error.code === "auth/too-many-requests") msg = "Too many attempts. Try again later.";
      this.$toasted.error(msg);
    },

    handleOtpPaste(e) {
      e.preventDefault();
      const pasteData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
      
      if (pasteData.length === 6) {
        for (let i = 0; i < 6; i++) {
          const input = document.getElementById(`digit-${i + 1}`);
          if (input) {
            input.value = pasteData[i];
          }
        }
        document.getElementById('digit-6').focus();
        this.otpSuccess = true;
      }
    },

    handleOtpInput(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
      this.otpError = false;
      
      if (e.target.value && e.target.nextElementSibling) {
        let next = e.target.nextElementSibling;
        if (next.classList.contains('splitter')) {
          next = next.nextElementSibling;
        }
        if (next) next.focus();
      }
      
      // Auto-verify when all 6 digits are filled
      const code = this.getOtpCode();
      if (code.length === 6) {
        this.otpSuccess = true;
        setTimeout(() => {
          this.verifyOTP();
        }, 300);
      }
    },

    handleOtpBackspace(e) {
      if (e.key === "Backspace" && !e.target.value && e.target.previousElementSibling) {
        let prev = e.target.previousElementSibling;
        // Skip the splitter
        if (prev.classList && prev.classList.contains('splitter')) {
          prev = prev.previousElementSibling;
        }
        if (prev) prev.focus();
      }
    },

    // clearOtpInputs() {
    //   for (let i = 1; i <= 6; i++) {
    //     const input = document.getElementById(`digit-${i}`);
    //     if (input) input.value = '';
    //   }
    //   document.getElementById('digit-1').focus();
    // },
  }
};
</script>

<!-- Your original style (untouched) -->
<style scoped>
.eyeButton {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 18px;
}
.digit-group input {
  width: 45px;
  height: 50px;
  text-align: center;
  font-size: 20px;
  margin: 0 5px;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.resend {
  cursor: pointer;
  text-decoration: underline;
}

.phone-signup {
  background: #ee5835;
  height: 50px;
  border-radius: 8px;
  color: #fff !important;
}

.phone-signup i {
  color: #fff;
}

.nxt-btn {
  border: none;
  background: #ee5835;
  height: 50px;
  border-radius: 8px;
  color: #fff !important;
}

.signin-back-btn {
  height: 50px;
  width: 50px;
  background: #ee5835;
  border-radius: 8px;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff !important;
}

.signin-back-btn i {
  color: #fff;
}

.spinner {
  color: #fff !important;
}

/* Your modern OTP styles - unchanged */
.otp-boxs {
  margin-top: 2rem;
}

.otp-boxs h6 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 1.5rem;
  text-align: center;
}

.digit-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.digit-group input {
  width: 50px;
  height: 56px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  background: #fff;
  color: #333;
  transition: all 0.3s ease;
  outline: none;
}

.digit-group input:focus {
  border-color: #ee5835;
  box-shadow: 0 0 0 3px rgba(238, 88, 53, 0.1);
  transform: scale(1.05);
}

.otp-timer-section {
  margin-top: 1.5rem;
  text-align: center;
}

.resend {
  color: #ee5835;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  display: inline-block;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.resend:hover {
  background: #fff5f3;
  text-decoration: none;
}
</style>